import React from "react";
import { BiFilterAlt } from "react-icons/bi";
import { PiMicrosoftExcelLogoLight } from "react-icons/pi";
import { RiFileExcel2Line } from "react-icons/ri";
import { FaRegFilePdf } from "react-icons/fa6";
import { BiDetail  } from "react-icons/bi";
import { RiMailSendLine } from "react-icons/ri";
import TooltipComponent from "./TooltipComponent";
import { LuUndoDot } from "react-icons/lu";
import { MdEventNote } from 'react-icons/md';
import { HiOutlineDownload } from "react-icons/hi";
import { RiDeleteBinLine } from "react-icons/ri";
import { CiViewList } from "react-icons/ci";
import { MdOutlineFilterList } from "react-icons/md";
import { MdOutlineFilterListOff } from "react-icons/md";
import { ImSpinner2 } from "react-icons/im";
import { HiOutlineClipboardList } from "react-icons/hi";
import { IoNotificationsOutline } from "react-icons/io5";

const BasicButton = React.memo((props) => {
  const handleClick = (event) => {
    if (props.onClick) {
      props.onClick(event);
    }
  };
  // props.loading => Used for show loading
  // props.loadingMessage => Used for show message text while loading
  // props.type => Used for set color of button
  // props.otherClasses  => Used for add other css classes
  return props.loading === true ? (
    <button type="button" className={`  text-white text-${props.textColor} rounded-${props.rounded} text-${props.textAlign} font-${props.fontWeight} ${ props.shadow && "grayBlurShadow"} ${props.className} cursor-pointer  ${props.padding || "py-2 px-3"} navAnimation`}>
      {props.loadingMessage}...
    </button>
  //   <button className={`text-white ${props.className} ${!props.disabled && "cursor-pointer"} ${props.disabled && "opacity-75"} rounded-${props.rounded} py-2 px-3 text-${props.textColor} text-${props.textAlign} font-${props.fontWeight} ${ props.shadow && "grayBlurShadow"} navAnimation`}>
  //     <span className={`flex items-center ${!props.loadingMessage && 'justify-center' }`}>
  //         props.loadingCss => custom classes passed for loader size or color
  //         <span
  //             className={`animate-spin rounded-full border-4 border-t-transparent w-2 border-gray-400`}
  //             role="status"
  //         >
  //             <span className="sr-only"></span>
  //         </span>
  //         <span className="ml-2">{props.loadingMessage}</span>
  //     </span> 
  // </button>
  ) : (
    <button id={props.id} type="submit"
      disabled={props.disabled}
      className={` text-white ${props.className} ${!props.disabled && "cursor-pointer"} ${props.disabled && "opacity-75"} rounded-${props.rounded} ${props.padding || "py-2 px-3"}  text-${props.textColor} text-${props.textAlign} font-${props.fontWeight} ${ props.shadow && "grayBlurShadow"} ${!props.disabled && props.onHover && `${props.onHover}`} navAnimation`}
      onClick={handleClick}>
      {props.buttonName}
    </button>
  );
});

export default BasicButton;

export const FilterBtn = React.memo(({id, disabled, filterCount, onClear, buttonName, loading, loadingMessage, onClick, className}) => {

  return loading === true ? (
    <button type="button" className={`relative flex items-center border rounded-lg px-4 py-2 ${className} cursor-pointer bg-white text-gray-600 `}>
      {filterCount?.() && 
      (<div className="absolute top-1 left-3 w-4 h-4 rounded-full bg-blue-700 text-white">
        <span className=" absolute -top-0.5 left-[4px] text-sm">{filterCount?.()}</span>
      </div>)}
      <BiFilterAlt className=" mr-1 text-lg"/>
      {loadingMessage}...
    </button>
  ) : (
    <button id={id} type="submit"
      disabled={disabled}
      className={`relative flex items-center border rounded-lg px-4 py-2 cursor-pointer hover:bg-gray-100 transition-all duration-300 ease-in-out  ${className} ${!disabled && "cursor-pointer"} bg-white text-gray-600 `}
      onClick={onClick}>
      {filterCount?.() && 
      (<div className="absolute top-1 left-3 w-4 h-4 rounded-full bg-blue-700 text-white">
        <span className=" absolute -top-0.5 left-[4px] text-sm">{filterCount?.()}</span>
      </div>)}
      <BiFilterAlt className=" mr-1 text-lg"/>
      {buttonName}
    </button>
  );
});
export const ExcelImportBtn = React.memo(({id, disabled, onClear, buttonName, loading, loadingMessage, onClick, className}) => {
  return loading === true ? (
    <button type="button" className={`relative flex items-center border rounded-lg px-4 py-2 ${className} cursor-pointer bg-white text-gray-600 `}>
      <PiMicrosoftExcelLogoLight className=" mr-1 text-lg"/>
      {loadingMessage}...
    </button>
  ) : (
    <button id={id} type="submit"
      disabled={disabled}
      className={`relative flex items-center border rounded-lg px-4 py-2 cursor-pointer hover:bg-gray-100 transition-all duration-300 ease-in-out  ${className} ${!disabled && "cursor-pointer"} bg-white text-gray-600 `}
      onClick={onClick}>
      <PiMicrosoftExcelLogoLight className=" mr-1 text-lg"/>
      {buttonName}
    </button>
  );
});
export const ExcelExportBtn = React.memo(({id, disabled, onClear, buttonName, loading, loadingMessage, onClick, className}) => {
  return loading === true ? (
    <button type="button" className={`relative flex items-center border rounded-lg px-4 py-2 ${className} cursor-pointer bg-white text-gray-600 `}>
      <RiFileExcel2Line className=" mr-1 text-lg"/>
      {loadingMessage}...
    </button>
  ) : (
    <button id={id} type="submit"
      disabled={disabled}
      className={`relative flex items-center border rounded-lg px-4 py-2 cursor-pointer hover:bg-green-200 transition-all duration-300 ease-in-out  ${className} ${!disabled && "cursor-pointer"} bg-white text-gray-600 `}
      onClick={onClick}>
      <RiFileExcel2Line className=" mr-1 text-lg"/>
      {buttonName}
    </button>
  );
});
export const PdfImportBtn = React.memo(({id, disabled, filterCount, onClear, buttonName, loading, loadingMessage, onClick, className}) => {

  return loading === true ? (
    <button type="button" className={`relative flex items-center border rounded-lg px-4 py-2 ${className} cursor-pointer bg-white text-gray-600 `}>
      {filterCount?.() && 
      (<div className="absolute top-1 left-3 w-4 h-4 rounded-full bg-blue-700 text-white">
        <span className=" absolute -top-0.5 left-[4px] text-sm">{filterCount?.()}</span>
      </div>)}
      <FaRegFilePdf className=" mr-1 text-lg"/>
      {loadingMessage}...
    </button>
  ) : (
    <button id={id} type="submit"
      disabled={disabled}
      className={`relative flex items-center border rounded-lg px-4 py-2 cursor-pointer hover:bg-gray-100 transition-all duration-300 ease-in-out  ${className} ${!disabled && "cursor-pointer"} bg-white text-gray-600 `}
      onClick={onClick}>
      {filterCount?.() && 
      (<div className="absolute top-1 left-3 w-4 h-4 rounded-full bg-blue-700 text-white">
        <span className=" absolute -top-0.5 left-[4px] text-sm">{filterCount?.()}</span>
      </div>)}
      <FaRegFilePdf className=" mr-1 text-lg"/>
      {buttonName}
    </button>
  );
});

export const HistoryButton = React.memo(({data, disabled = false, tooltipName, position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div className={`flex justify-center items-center border border-blue-950 text-blue-950 px-1 py-1 rounded-md ${!disabled ? "hoverGreen cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
          <BiDetail onClick={handleClick} className=' text-2xl' />
      </div>
    </TooltipComponent>
  )
});
export const EmailSendButton = React.memo(({data, disabled = false, tooltipName, position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div className={`flex justify-center items-center border border-blue-950 text-blue-950 px-1 py-1 rounded-md ${!disabled ? "hoverGreen cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
          <RiMailSendLine onClick={handleClick} className=' text-2xl ' />
      </div>
    </TooltipComponent>
  )
});
export const RevertStatusButton = React.memo(({data, disabled = false, tooltipName, position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div className={`flex justify-center items-center border border-blue-950 text-blue-950 px-1 py-1 rounded-md ${!disabled ? "hoverGreen cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
          <LuUndoDot onClick={handleClick} className=' text-2xl ' />
      </div>
    </TooltipComponent>
  )
});
export const InterviewButton = React.memo(({data, disabled = false, tooltipName, position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div className={`flex justify-center items-center border border-blue-950 text-blue-950 px-1 py-1 rounded-md ${!disabled ? "hoverGreen cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
          <MdEventNote onClick={handleClick} className=' text-2xl ' />
      </div>
    </TooltipComponent>
  )
});
export const DownloadButton = React.memo(({data, disabled = false, tooltipName, position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div className={`flex justify-center items-center border border-blue-950 text-blue-950 px-1 py-1 rounded-md ${!disabled ? "hoverGreen cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
          <HiOutlineDownload onClick={handleClick} className=' text-2xl ' />
      </div>
    </TooltipComponent>
  )
});
export const DeleteButton = React.memo(({data, disabled = false, tooltipName, position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div className={`flex justify-center items-center border border-red-500 text-red-500 px-1 py-1 rounded-md ${!disabled ? " hover:bg-red-200 cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
          <RiDeleteBinLine onClick={handleClick} className=' text-2xl ' />
      </div>
    </TooltipComponent>
  )
});
export const ListButton = React.memo(({data, className, zIndex, disabled = false, tooltipName = "List Candidate", position = 'left', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <div className={`fixed z-${zIndex || 10} ${className || "bottom-3.5 right-16"}`}>
      <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
        <div className={`flex justify-center items-center border border-blue-950 text-blue-950 bg-white px-1 py-1 rounded-md ${!disabled ? " hover:bg-blue-200 cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
            <CiViewList onClick={handleClick} className=' text-2xl ' />
        </div>
      </TooltipComponent>
    </div>
  )
});
export const DateWiseListButton = React.memo(({data, className, zIndex, disabled = false, tooltipName = "Date Wise Candidate", position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <div className={`fixed z-${zIndex || 10} ${className || "bottom-3.5 right-16"}`}>
      <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
        <div className={`flex justify-center items-center border border-blue-950 text-blue-950 bg-white px-1 py-1 rounded-md ${!disabled ? " hover:bg-blue-200 cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
            <CiViewList onClick={handleClick} className=' text-2xl ' />
        </div>
      </TooltipComponent>
    </div>
  )
});
export const FilterButton = React.memo(({data, loading = false, disabled = false, tooltipName = "Filter", position = "bottom", onClick}) => {
    const handleClick = (event) => {
      const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
      if (!disabled && !loading) onClick?.(syntheticEvent);
    };

    return (
      <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
        <div
          className={`flex justify-center items-center border border-blue-950 text-white bg-blue-800 px-1 py-1 rounded-md ${
            !disabled ? "hover:bg-blue-700 cursor-pointer transition-all duration-300 ease-in-out"
            : "cursor-not-allowed bg-blue-200 opacity-60"
          }`}
        >
          {loading ? (
            <ImSpinner2 className="text-4xl p-1 animate-spin" />
          ) : (
            <MdOutlineFilterList onClick={handleClick} className="text-4xl p-1" />
          )}
        </div>
      </TooltipComponent>
    );
  }
);
export const ClearButton = React.memo(({data, disabled = false, tooltipName = "Clear", position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div className={`flex justify-center items-center border border-red-950 text-white bg-red-700 px-1 py-1 rounded-md ${!disabled ? " hover:bg-red-600 cursor-pointer transition-all duration-300 ease-in-out" : " cursor-not-allowed bg-red-200 opacity-60" }`}>
          <MdOutlineFilterListOff onClick={handleClick} className=' text-4xl p-1 ' />
      </div>
    </TooltipComponent>
  )
});
export const FollowupButton = React.memo(({data, notify = false, disabled = false, tooltipName = "Followup", position = 'bottom', onClick})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div className={`relative flex justify-center items-center border border-blue-950 text-blue-950 bg-white px-1 py-1 rounded-md ${!disabled ? " hoverGreen cursor-pointer" : " cursor-not-allowed bg-gray-200 opacity-60" }`}>
          <HiOutlineClipboardList onClick={handleClick} className=' text-2xl ' />
          {notify !== false && notify >= 0 && (
            <div
              className={`absolute -top-1 -right-1 rounded-full w-2.5 h-2.5 ${
                notify === 0
                  ? "bg-green-600"
                  : notify === 1
                  ? "bg-yellow-500"
                  : "bg-red-600"
              }`}
            />
          )}
      </div>
    </TooltipComponent>
  )
});

export const NotificationIconButton = React.memo(({data, disabled = false, tooltipName, position = 'bottom', onClick, notify = false})=> {
  const handleClick = (event)=> {
    const syntheticEvent = {
        ...event,
        target: { ...event.target, value: data },
      };
    if(!disabled) onClick?.(syntheticEvent);
  }
  return (
    <TooltipComponent name={!disabled ? tooltipName : ""} position={position}>
      <div
          className={`relative flex justify-center items-center border border-gray-300 text-white bg-blue-950 px-3 py-3 rounded-full shadow-md transition-all duration-200 ${
            !disabled
              ? "hover:shadow-lg cursor-pointer hoverGreen hover:border-gray-600"
              : "cursor-not-allowed bg-gray-200 opacity-60"
          }`}
        >
          <IoNotificationsOutline
            onClick={handleClick}
            className={`text-3xl ${notify ? "animate-bell" : ""}`}
          />
          {/* Blinking Dot for New Notification */}
            {notify && (
              <span className="absolute top-1 right-1 flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
              </span>
            )}
      </div>

    </TooltipComponent>
  )
});